import javascriptSvg from './javascript.svg';
import angularSvg from './angular.svg';
import reactSvg from './react.svg';
import vueSvg from './vue.svg';
import vueInvertedSvg from './vue_inverted.svg';

const fw_logos = {
    javascript: javascriptSvg,
    angular: angularSvg,
    react: reactSvg,
    vue: vueSvg,
    vueInverted: vueInvertedSvg
};

export default fw_logos;
